import styled from 'styled-components';

import {
  spaceS,
  cornerRadiusM,
  spaceXL,
  xdlColorBackgroundTertiary,
  xdlColorTextSecondary,
  xdlPaletteMint07,
  xdlColorText,
} from '@xing-com/tokens';
import { Meta, Headline } from '@xing-com/typography';

const Title = styled(Headline)`
  text-align: center;
  margin-bottom: ${spaceXL};
`;

const MedianSalary = styled(Headline)`
  margin: 0 auto;
`;

const Bar = styled.div`
  height: 8px;
  min-height: 8px;
  background-color: ${xdlColorBackgroundTertiary};
  border-radius: ${cornerRadiusM};
  margin-top: ${spaceS};
`;

const BarFill = styled.div`
  height: 100%;
  background-color: ${xdlPaletteMint07};
  border-radius: ${cornerRadiusM};
  width: 15px;
  margin: 0 auto;
`;

const Range = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${spaceS};
  margin-bottom: ${spaceXL};
`;

const RangeItem = styled(Meta)`
  color: ${xdlColorText};
  margin: 0;
`;

const Label = styled.div`
  display: flex;
`;

const LabelBar = styled.div`
  width: 24px;
  height: 8px;
  border-radius: ${cornerRadiusM};
  margin-right: ${spaceS};
  margin-top: 6px;
`;

const LabelBarAverage = styled(LabelBar)`
  background-color: ${xdlPaletteMint07};
`;

const LabelBarRange = styled(LabelBar)`
  background-color: ${xdlColorBackgroundTertiary};
`;

const LabelText = styled(Meta)``;

const Note = styled(Meta)`
  color: ${xdlColorTextSecondary};
  margin: ${spaceXL} 0 0 0;
`;

export default {
  MedianSalary,
  Title,
  Bar,
  BarFill,
  Range,
  RangeItem,
  Label,
  LabelBarAverage,
  LabelBarRange,
  LabelText,
  Note,
};
